import React from 'react';
import ContactTile from '@gik/contact/components/ContactTile/ContactTile';
import { FacebookIcon, InstagramIcon, PinterestIcon, TwitterIcon } from '@gik/ui';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/contact/i18n/en';

export default function Connect() {
  const bem = useBemCN('connect');
  const { t } = useTranslation();

  return (
    <ContactTile {...bem()} title={t(translationKeys.ConnectTitle)}>
      <div>
        <FacebookIcon href="https://www.facebook.com/giveinkind/" />
        <PinterestIcon href="https://www.pinterest.com/giveinkind" />
        <InstagramIcon href="https://www.instagram.com/giveinkind/" />
        <TwitterIcon href="https://twitter.com/giveinkind" />
      </div>
    </ContactTile>
  );
}
